module.exports = __webpack_public_path__ + "static/img/22.69d896b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22.jpg
// module id = H2aL
// module chunks = 1